import {  GetRequest } from "../service"

const ControllerName = "Accreditation" 

export const GetAccredationsLookup = () => {
    return GetRequest(`${ControllerName}/lookup`)
}